var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignDistributionOfElementsOfAnArticleSvgrepoCom1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2517 6.00586H4.69754C3.8913 6.00586 3.23828 6.65888 3.23828 7.46512C3.23828 8.27136 3.8913 8.92438 4.69754 8.92438H15.2517C16.0579 8.92438 16.7109 8.27136 16.7109 7.46512C16.7109 6.65892 16.0579 6.00586 15.2517 6.00586Z",
    fill: "#FF7A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2533 16.4473H8.20145C7.39521 16.4473 6.74219 17.1003 6.74219 17.9065C6.74219 18.7127 7.39521 19.3658 8.20145 19.3658H15.2533C16.0596 19.3658 16.7126 18.7128 16.7126 17.9065C16.7126 17.1003 16.0596 16.4473 15.2533 16.4473Z",
    fill: "#FF7A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2533 11.2266H2.12723C1.32099 11.2266 0.667969 11.8796 0.667969 12.6858C0.667969 13.4921 1.32099 14.1451 2.12723 14.1451H15.2533C16.0596 14.1451 16.7126 13.4921 16.7126 12.6858C16.7126 11.8796 16.0595 11.2266 15.2533 11.2266Z",
    fill: "#FF7A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2533 21.6719H2.12723C1.32099 21.6719 0.667969 22.3248 0.667969 23.1311C0.667969 23.9374 1.32099 24.5904 2.12723 24.5904H15.2533C16.0596 24.5904 16.7126 23.9374 16.7126 23.1311C16.7126 22.3249 16.0595 21.6719 15.2533 21.6719Z",
    fill: "#FF7A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2533 26.8926H2.12723C1.32099 26.8926 0.667969 27.5456 0.667969 28.3518C0.667969 29.1581 1.32099 29.8111 2.12723 29.8111H15.2533C16.0596 29.8111 16.7126 29.1581 16.7126 28.3518C16.7126 27.5456 16.0595 26.8926 15.2533 26.8926Z",
    fill: "#FF7A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4773 5.8457H21.5483C20.3407 5.8457 19.3594 6.82706 19.3594 8.0346V27.9645C19.3594 29.172 20.3407 30.1534 21.5483 30.1534H34.4773C35.6849 30.1534 36.6662 29.172 36.6662 27.9645V8.0346C36.6662 6.82341 35.6885 5.8457 34.4773 5.8457Z",
    fill: "#FF7A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.667969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignDistributionOfElementsOfAnArticleSvgrepoCom1);
export default __webpack_public_path__ + "static/media/design-distribution-of-elements-of-an-article-svgrepo-com 1.3de2cdf2e782b8b2cbc555abd912de9d.svg";
export { ForwardRef as ReactComponent };